// extracted by mini-css-extract-plugin
export default {"BM_Container":"style_BM_Container__1zg8y","lineWrapper":"style_lineWrapper__WDREu","line1":"style_line1__5psoB","line2":"style_line2__SjI1J"};